export { confirmDialog } from './openConfirmDialog';
export type { ConfirmOptions, ConfirmTone } from './ConfirmDialog';
